import {
  Theme,
  border2,
  heading,
  rem,
  spacing,
  token,
} from '@thiememeulenhoff/lit-sdk';
import { css } from 'lit';
import { tagName } from '../../helpers';

export const tag = tagName('side-panel');
export const theme = new Theme(tag);

export const asideStyles = [
  css`
    aside {
      background-color: ${token('background-secondary')};
      block-size: 100%;
      border-inline-end: ${border2(1, 'border-secondary')};
      display: flex;
      flex-direction: column;

      ${theme.props([['inline-size', `inline-size`, rem(354)]])};

      .header {
        align-items: center;
        background: ${token('background-secondary')};
        border-block-end: ${border2(1, 'border-secondary')};
        display: flex;
        gap: ${spacing(100)};
        inset-block-start: 0;
        justify-content: center;
        padding-block: ${spacing(100)};
        padding-inline: ${spacing(75)};
        position: sticky;
      }

      .label {
        align-items: center;
        display: flex;
        flex: 1;
        gap: ${spacing(100)};
        padding-inline: ${spacing(150)} 0;

        ${heading()}
      }

      .close-button::part(icon) {
        color: ${token('text-primary')};
      }

      .main {
        flex: 1;
        overflow-x: auto;
        padding-inline: ${spacing(75)};
      }
    }

    aside:focus {
      outline: none;
    }

    a-drawer .label {
      align-items: center;
      display: flex;
    }

    a-drawer::part(header) {
      padding-inline-start: ${spacing(75)};
    }

    a-drawer::part(main) {
      padding-inline: ${spacing(75)};
    }

    :host(:not([collapsable]):not([is-open])) aside {
      display: none;
    }

    :host([collapsable]:not([is-open])) aside {
      inline-size: auto;
      max-inline-size: 30dvw;
      min-block-size: 100%;
    }

    :host([collapsable]):not([is-open]) aside .label {
      display: none;
    }

    :host([position='end']) aside {
      border-inline-end: 0;
      border-inline-start: ${border2(1, 'border-secondary')};
    }
  `,
];

export const styles = [
  css`
    :host {
      background: ${token('background-secondary')};
      box-sizing: border-box;
      display: flex;
      flex-direction: row;
      overflow: hidden;
      position: relative;

      ${theme.props([
        [
          'block-size',
          `block-size`,
          'calc(100dvh - var(--tm-header-height, 0px) - var(--tm-addon-content-height, 0px))',
        ],
      ])};
    }

    .main {
      ${theme.props([
        ['inline-size', 'inline-size', 'fit-content'],
        ['min-inline-size', 'min-inline-size', 'auto'],
      ])};

      flex: 1;
      overflow-x: auto;
    }
  `,
];
